module.exports = __webpack_public_path__ + "img/5.a061bdb2.png";